import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { selectBadgeCount } from '@store/selectors/customerInfo';
import { selectShopEventStatus } from '@store/selectors/shopEvent';
import {
  selectBasketRehydrated,
  selectBasketShopEventId,
} from '@selectors/basket';
import { clearBasket } from '@store/actions/basket';

import { ThemeProvider } from '@common/contexts/themeContext';
import { useAnalytics } from '@common/hooks/useAnalytics';
import useFavicon from '@common/hooks/useFavicon';

export const Providers = ({ children, router, pageProps }) => {
  const dispatch = useDispatch();
  const vipBadgeCount = useSelector(selectBadgeCount);
  const { shopEventId } = useSelector(selectShopEventStatus);
  const basketShopEventId = useSelector(selectBasketShopEventId);
  const isBasketStateRehydrated = useSelector(selectBasketRehydrated);

  useEffect(() => {
    // Got to handle client side only as persisted basket state is not yet available on server side
    if (isBasketStateRehydrated && shopEventId !== basketShopEventId) {
      dispatch(clearBasket());
    }
  }, [isBasketStateRehydrated, shopEventId, basketShopEventId, dispatch]);

  useAnalytics(router, pageProps?.pageData?.meta?.langUrls?.de);

  useFavicon(
    `/static/img/favicon/favicon${vipBadgeCount > 0 ? '-notification' : ''}.ico`,
  );

  return <ThemeProvider>{children}</ThemeProvider>;
};
